import { render, staticRenderFns } from "./EventArchive.vue?vue&type=template&id=9378c068&"
import script from "./EventArchive.vue?vue&type=script&lang=js&"
export * from "./EventArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports